import { getTrackingUrl } from "v2/src/constants/trackingConstants";
import { Link, Stack, Typography } from "@mui/material";

interface TrackingItem {
  carrierName?: string;
}

interface TrackingInfo {
  trackNum?: string;
  deliveryMethod?: string;
  items?: TrackingItem[];
}

export default function IntegrationCenterTrackingOrderLink({
  tracking,
}: Readonly<{
  tracking: TrackingInfo;
}>) {
  const trackingNumber = tracking.trackNum;
  const carrierName = tracking.items?.[0]?.carrierName || "";
  const deliveryMethod = tracking.deliveryMethod || "";

  if (!trackingNumber) {
    return null;
  }

  const trackingUrl = getTrackingUrl(
    carrierName,
    deliveryMethod,
    trackingNumber,
  );

  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
        Tracking Number:
      </Typography>
      {trackingUrl && (
        <Link
          href={trackingUrl}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          sx={{
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          {trackingNumber}
        </Link>
      )}
      {!trackingUrl && (
        <Typography
          component="span"
          variant="caption"
          sx={{
            fontWeight: 500,
            color: "text.primary",
          }}
        >
          {trackingNumber}
        </Typography>
      )}
    </Stack>
  );
}
